import { create } from "@mui/material/styles/createTransitions";
import axios from "axios";

export const bucketUrl =
  process.env.REACT_APP_API_URL || "https://nexus-dev.ph-dse.int.bayer.com/api/";
export const explorerUrl = process.env.REACT_APP_S3_EXPLORERUrl;
export const hostnameUrl = process.env.REACT_APP_AUTH_REDIRECT_URI;
export const datazoneurl = process.env.REACT_APP_API_URL;

export const nexus_api_base_url_v1 =  process.env.REACT_APP_NEXUS_API_BASE_URL;
export const nexus_api_base_url_v2 =  process.env.REACT_APP_NEXUS_API_BASE_URL
  ? process.env.REACT_APP_NEXUS_API_BASE_URL.replace(/\/v1$/, "/v2")
  : undefined;
// const config = {

//   AUTHZ_API_URL: 'https://ead6qtvaxe.execute-api.eu-central-1.amazonaws.com/dev-1944',

//   AUTH_CLIENT_ID: '6dedf227-6e83-46c1-bebe-aeaae995db78',

//   AUTH_REDIRECT_URI: 'https://nexus-dev.ph-dse.int.bayer.com/s3explorer/ok.html',

//   AZURE_TENANT: 'fcb2b37b-5da0-466b-9b83-0014b67a7c78',

//   DATAPOND_API_URL: 'https://iwa6wtc3ce.execute-api.eu-central-1.amazonaws.com/api/',

//   NEXUS_API_BASE_URL: 'https://ml-services.992382651944.cloud.bayer.com/api/v1',

//   DATAZONE_URL: 'https://dzd_55sr8gusmxyopz.datazone.us-east-1.on.aws',

// };


const $datazoneUrlHost = axios.create({
  baseURL: datazoneurl, 
});

const $bucketUrlHost = axios.create({
  baseURL: bucketUrl,
});

const $explorerUrlHost = axios.create({
  baseURL: explorerUrl,
});

const $nexus_api_base_url_v1 = axios.create({
  baseURL: nexus_api_base_url_v1,
});

const $nexus_api_base_url_v2 = axios.create({
  baseURL: nexus_api_base_url_v2,
});

export { $bucketUrlHost, $explorerUrlHost, $datazoneUrlHost, $nexus_api_base_url_v1, $nexus_api_base_url_v2 };
